import useAppState from '../../context/AppContext';
import { IContactType } from '../../context/model';
import MgpFormCheckbox from '../../elements/MgpFormCheckbox/MgpFormCheckbox';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import MgpFormRadioBox from '../../elements/MgpFormRadioBox/MgpFormRadioBox';
import { accessJsonAttr } from '../../utils/utils';
import { UseFormRegister, UseFormSetError, UseFormSetValue, UseFormWatch } from 'react-hook-form';


export type InfoContactFormData = {
  email: string,
  showCommercialMgpChoice: boolean,
  phoneNumber: string,
  isForeignMobile: boolean
  commercialEmailAccept: string,
  commercialSmsAccept: string,
  commercialTelephoneAccept: string,
  commercialPartnerAccept: string,
}

type InfoContactTemplateProps = {
    register: UseFormRegister<any>;
    errors: any;
    showCommercialMgpChoice?: boolean;
    watch : UseFormWatch<InfoContactFormData>;
    setValue : UseFormSetValue<InfoContactFormData>;
    setError : UseFormSetError<InfoContactFormData>;
}

export default function InfoContactTemplate({register, errors, showCommercialMgpChoice, watch, setValue, setError } : Readonly<InfoContactTemplateProps>) {

    const {
      state: { updatedProposition, proposition }
    } = useAppState();
    
  const isForeignMobileValue = watch("isForeignMobile");
  const isClient = proposition?.configuration?.byContactType === IContactType.CLIENT;

  const handleChangeisForeignMobileCheckbox = (e: any) => {
    setValue("isForeignMobile", e.target.checked);

    if (e.target.checked) {
      setValue("phoneNumber", "+");
      setError("phoneNumber", {});
    } else {
      setValue("phoneNumber", "");
      setError("phoneNumber", {});
    }
  }

  const handleChangePhoneNumber = (e: any) => {
    const regexSpace = new RegExp("(.{"+ 2 + "})", "g");
    let target = e.currentTarget, position = target.selectionEnd, length = target.value.length;
    target.value = target.value.replace(/\s/g, '').replace(regexSpace, '$1 ').trim();
    target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
    setValue("phoneNumber", target.value);
  }

    return (          
      <form style={{width: '100%'}}>
        <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <h2 className='card-title bleu mb-xs'>Mes modalités de contact</h2>
            <p className='text pb-sm' style={{textAlign: 'justify'}}>Vos coordonnées sont nécessaires à la gestion de votre contrat frais de santé. Ces données doivent donc être saisies avec exactitude.
            </p>
            <div className=""> 
              <div className='form-row'>
                <div className="form-group mw-100">
                  <MgpFormInput
                      label="Email personnel"
                      id="email"
                      labelFontWeight='regular'
                      register={register} 
                      errors={errors}
                      required={!isClient}
                      readOnly={isClient}
                      value={isClient ? proposition?.contact?.email : watch('email')}
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className="form-group mw-100">
                  <p className='text fw-medium'>Numéro de téléphone portable {!isClient && <span className='fushia'>(*)</span>}</p>
                  <div className='form-group form-check mw-100'>
                    <MgpFormCheckbox
                      id='isForeignMobile' 
                      label="Numéro hors France métropolitaine" 
                      register={register} 
                      errors={errors} 
                      required={false}
                      inputSize='small'
                      onChange={(e: any) => handleChangeisForeignMobileCheckbox(e)}
                      disabled={isClient}
                    />
                  </div>
  
                  <div className='mt-sm'>
                  {
                    isForeignMobileValue ?
                    <MgpFormInput
                      label=""
                      id="phoneNumber"
                      placeholder="Ex: 00xxxxxxxx ou +xxxxxxxxxx"
                      labelFontWeight='medium'
                      maxLength={15}
                      register={register} 
                      errors={errors}
                      required={!isClient}
                      value={isClient ? proposition?.contact?.phoneNumber : watch("phoneNumber")}
                      readOnly={isClient}
                    />
                    :
                    <MgpFormInput
                      label=""
                      id="phoneNumber"
                      placeholder="Ex: 06 05 04 03 02"
                      labelFontWeight='medium'
                      maxLength={14}
                      autospace={2}
                      register={register} 
                      errors={errors}
                      required={!isClient}
                      value={isClient ? proposition?.contact?.phoneNumber : watch("phoneNumber")}
                      onChange={(e) => handleChangePhoneNumber(e)}
                      readOnly={isClient}
                    />
                  }
                </div>
                  {
                    isForeignMobileValue && !isClient &&
                    <div className="form-group mw-100 mt-sm">
                      <p className='bg-menthe blanc p-xs flex va-center jc-start' style={{gap: "10px", flexWrap: "unset"}}>
                        <i className='icon-info blanc '></i>
                        <span >Veuillez saisir votre numéro de mobile complet avec l'indicatif.</span>
                      </p>
                    </div>
                  }       
                </div>
              </div>                   
            </div>
          </div>

          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>  
            <p className='text ta-justify'>Vos besoins évoluent : bénéficiez de conseils personnalisés et d’informations sur les offres et services proposés par la MGP.</p>
            <p className='text ta-justify mb-sm'>J'accepte de recevoir des informations sur les solutions proposées par la MGP&nbsp;:</p>
   
            {showCommercialMgpChoice&&
            <>
            <div className="form-row">
              <p className='form-check-label fw-medium text custom'>Par téléphone<span className='fushia'> (*)</span></p>
              <div className="form-group form-group-radio form-group-radio-custom">
                <MgpFormRadioBox id ='commercialTelephoneAccept' value='true' register={register} label="Oui" errors={errors} />
                <MgpFormRadioBox id ='commercialTelephoneAccept' value='false' register={register} label="Non" errors={errors} />
              </div>
            </div>
            <div className="form-row">
              <p className='form-check-label fw-medium text custom'></p>
              {errors && accessJsonAttr(errors, 'commercialTelephoneAccept') && <p className="error">Ce champ est obligatoire</p>}
            </div>
            <div className="form-row">
              <p className='form-check-label fw-medium text custom'>Par mail<span className='fushia'> (*)</span></p>
              <div className="form-group form-group-radio form-group-radio-custom">
                <MgpFormRadioBox id ='commercialEmailAccept' value='true' register={register} label="Oui" errors={errors} />
                <MgpFormRadioBox id ='commercialEmailAccept' value='false' register={register} label="Non" errors={errors} />
              </div>
            </div>
            <div className="form-row">
              <p className='form-check-label fw-medium text custom'></p>
              {errors && accessJsonAttr(errors, 'commercialEmailAccept') && <p className="error">Ce champ est obligatoire</p>}
            </div>
           
            <div className="form-row">
              <p className='form-check-label fw-medium text custom'>Par SMS<span className='fushia'> (*)</span></p>
              <div className="form-group form-group-radio form-group-radio-custom">
                <MgpFormRadioBox id ='commercialSmsAccept' value='true' register={register} label="Oui" errors={errors} />
                <MgpFormRadioBox id ='commercialSmsAccept' value='false' register={register} label="Non" errors={errors} />
              </div>
            </div>
            <div className="form-row mb-md">
              <p className='form-check-label fw-medium text custom'></p>
              {errors && accessJsonAttr(errors, 'commercialSmsAccept') && <p className="error">Ce champ est obligatoire</p>}
            </div>
            </>}
           
            <div className="mt-xl">
              <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
            </div>
          
          </div>
        </div>
      </form>
  )
}
